import { useMemo, Fragment } from 'react';
import classNames from 'classnames';
import { Conversation } from 'src/types';
import { getTaskDisplayDate } from 'src/utils';
import { DEFAULT_CHAT_ID } from 'src/constants';
import styles from './ConversationsGroupedByDate.module.scss';
import { ConversationItem } from '../ConversationItem';

interface ConversationGroupProps {
  date: string;
  conversations: Conversation[];
  selectedConversationIds?: (string | null)[];
}

export const ConversationsGroupedByDate = ({
  date,
  conversations,
  selectedConversationIds,
}: ConversationGroupProps) => {
  const conversationDate = useMemo(() => getTaskDisplayDate(date), [date]);

  const shouldShowDateTitle = useMemo(() => {
    if (
      conversationDate === 'Today' &&
      conversations.length === 1 &&
      conversations[0].conversation_id === DEFAULT_CHAT_ID
    ) {
      return false;
    }
    return true;
  }, [conversations, conversationDate]);

  return (
    <Fragment>
      <div
        className={classNames(styles.root, {
          [styles.hiddenDate]: !shouldShowDateTitle,
        })}
      >
        <div className={styles.date}>
          <span>{conversationDate}</span>
        </div>
        {conversations.map((conversation: Conversation, index: number) => {
          const linkedConversationId = conversation?.linked_conversation_id;
          const linkedConversationData = linkedConversationId
            ? conversations.find(
                ({ conversation_id }) =>
                  conversation_id === linkedConversationId,
              )
            : undefined;

          return (
            <ConversationItem
              key={`thread-${conversation.conversation_id}`}
              selected={selectedConversationIds?.includes(
                conversation?.conversation_id ?? '',
              )}
              conversation={conversation}
              linkedConversation={linkedConversationData}
            />
          );
        })}
      </div>
    </Fragment>
  );
};
